import Core from "./core"
import Suspensions from "@hub/management/src/modules/suspensions/store"
import Role from "@hub/management/src/modules/roles/store"
import Chain from "@hub/management/src/modules/chains/store"
import Pos from "@hub/management/src/modules/pos/store"
import User from "@hub/management/src/modules/users/store"


const Store = {
  namespaced: true,
  modules: {
    Core,
    Suspensions,
    Role,
    Chain,
    Pos,
    User
  }
}

export default Store
